module.exports = __webpack_public_path__ + "img/service.086be04b.png";